import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import {
  SavedSearchCreateUpdateResponse,
  SaveSearchItem,
  SaveSearchParams,
  SaveSearchPayload,
  SaveSearchResponse,
} from '../../dto';
import { SavedSearchInterface } from 'src/app/modals/intent-settings/models';
import { UniversalSearchRequestModelInterface } from '../../../core/models';

@Injectable({
    providedIn: 'root'
})
export class SaveSearchApiService {
    private readonly url: string = 'service/contactcloud/search/savedSearch';

    constructor(
        private readonly baseApiService: BaseApiService,
    ) { }

    getSavedSearch(): Observable<SavedSearchInterface[]> {
        return this.baseApiService.get<SavedSearchInterface[]>(`${this.url}/allPublic`);
    }

    getSavedSearchList(params: SaveSearchParams): Observable<SaveSearchResponse> {
        return this.baseApiService.get<SaveSearchResponse>(this.url, { params: {...params} });
    }

    getFilteredSavedSearchList(filterData: SaveSearchParams): Observable<SaveSearchResponse> {
        return this.baseApiService.post<SaveSearchResponse>(`${this.url}/list`, filterData);
    }

    createSearch<T extends UniversalSearchRequestModelInterface>(information: SaveSearchPayload, query: T): Observable<SavedSearchCreateUpdateResponse<T>> {
        const parameters = {
            information: information,
            query: query
        };
        return this.baseApiService.post<SavedSearchCreateUpdateResponse<T>>(this.url, parameters, { showError: true }); //{ accept: 'application/vnd.snake+json' }
    }

    updateSearch<T>(itemId: string, query: T, searchType: string): Observable<SavedSearchCreateUpdateResponse<T>> {
        const parameters = {
            information: { type: searchType },
            query: query
        };

        return this.baseApiService.put<SavedSearchCreateUpdateResponse<T>>(`${this.url}/${itemId}`, parameters, { showError: true }); //{ 'accept': 'application/vnd.snake+json' }
    }

    deleteSavedSearch(savedSearchId: number): Observable<{ response: string }> {
        return this.baseApiService.delete<{ response: string }>(`${this.url}/${savedSearchId}`);
    }

    updateSavedSearchName(savedSearchId: number, information: Partial<SaveSearchPayload>): Observable<SaveSearchItem> {
        const parameters = {
            information: information
        };
        return this.baseApiService.put<SaveSearchItem>(`${this.url}/${savedSearchId}`, parameters, { showError: true });
    }
}
